.information-text {
  font-style: normal;
  font-size: 1.4rem;
  line-height: 1.9rem;
  color: #959bab;
}
